// Dependencies
import {
  TARIFAS_VENTA_REQUEST,
  TARIFAS_VENTA_OK,
  TARIFAS_VENTA_ERROR,
} from "./types";

const initialState = {
  qty: null,
  data: [],
  loading: false,
  error: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case TARIFAS_VENTA_REQUEST:
      return { ...state, loading: true };
    case TARIFAS_VENTA_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    case TARIFAS_VENTA_OK:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        qty: action.payload.qty,
      };
    default:
      return {
        ...state,
      };
  }
};

export default reducer;
